export default __webpack_public_path__ + "f07c7bf4858aaea13ff69d1d3b7097e2.png";